import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IPagination } from '../model/pagination';
import { NuevaPeticion, ParametrosCliente, ParametrosUpdate, UserPeticiones, Userprofile, UsuarioSearch, UsuarioUpdate } from '../model/users';
import { UsuarioCliente } from '../model/usuario-cliente';



@Injectable()
export class UsersService {
    PATH = '';
    PATH_PETICIONES = '';
    PATH_VIDEO_INICIAL = '';
    PATH_ACT_VIDEO_INICIAL = '';
    PATH_ACT_EXTRAER_SERIES_ALMACEN = '';
    videoInicialMostrado = false;

    constructor(private http: HttpClient) {
        this.PATH = environment.API_BASE + '/Users';
        this.PATH_PETICIONES = environment.API_BASE + '/Supervision';
        this.PATH_VIDEO_INICIAL = environment.API_BASE + '/Users/VideoInicial';
        this.PATH_ACT_VIDEO_INICIAL = environment.API_BASE + '/Users/ActualizarVideoInicial';
        this.PATH_ACT_EXTRAER_SERIES_ALMACEN = environment.API_BASE + '/Users/PermisoExtraerSeriesAlmacen';
        // /Users/ActivateUser/{IdUser}/{Active}
    }

    // Coge todos los usuarios (válido para supervisor o admin)
    // hay que diferenciar roles y devolver a todos, o por supervisor cliente
    getAllUsers(): Observable<Userprofile[]> {
        return this.http.get<Userprofile[]>(this.PATH + '/GetDetailsOfAllUser');
    }


    getFindUsers(filters: UsuarioSearch, n: number, m: number): Observable<any> {
        return this.http.post<any>(this.PATH + '/Find/' + n + '/' + m, filters);
    }


    getUsersPetitions(from: number, to: number, filtros: any[]): Observable<IPagination<UserPeticiones>> {
        const observable = this.http.post<any>(this.PATH_PETICIONES + '/' + from + '/' + to, filtros)
            .pipe(map((usersPetitions: IPagination<UserPeticiones>) =>
                IPagination.toModel<UserPeticiones>(JSON.stringify(usersPetitions), UserPeticiones)));
        return observable as Observable<IPagination<UserPeticiones>>;
    }


    // Coge el usuario por su identificador
    getUserById(userId: number): Observable<Userprofile> {
        return this.http.get<Userprofile>(this.PATH + '/' + (userId ? userId : '0'))
            .pipe(map((user: Userprofile) => Userprofile.toModel(JSON.stringify(user))));
    }

    getUserNameById(userId: number): Observable<string> {
        return this.http.get<string>(this.PATH + '/Name/' + (userId ? userId : '0'));
    }

    // Update user
    updateUser(user: UsuarioUpdate): Observable<any> {
        return this.http.patch(this.PATH, user, { observe: 'response' });
    }

    // Change password
    changePasswordUser(user: UsuarioUpdate): Observable<number> {
        return this.http.patch(this.PATH, user, { observe: 'response' })
            .pipe(map(success => success.status));
    }

    changeLevelSecurity(userId: number, levelSecurity: number): Observable<number> {
        const object = { USER_ID: userId, LEVEL_SECURITY: levelSecurity };
        return this.http.post<number>(this.PATH + '/ChangeLevelSecurity', object);
    }

    changeStatusUser(userId: number, activar: boolean): Observable<number> {
        return this.http.get(this.PATH + '/ActivateUser/' + userId + '/' + activar, { observe: 'response' })
            .pipe(map(success => success.status));
    }

    forceUserPasswordReset(user: string) {
        return this.http.post(this.PATH_PETICIONES + '/Resend', { USER: user });
    }

    // crea un nuevo usuario
    createUserPeticion(idpeticion: number): Observable<any> {
        return this.http.post(this.PATH_PETICIONES + '/Accept/' + idpeticion, { observe: 'response' })
            .pipe(map(success => success));
    }
    // crea una nueva petición de alta de usuario
    createNuevaPeticion(peticion: NuevaPeticion): Observable<any> {
        return this.http.post(this.PATH_PETICIONES, peticion, { observe: 'response' })
            .pipe(map(success => success));
    }
    // crea un usuario directamente
    createUserDirecto(usuario: NuevaPeticion): Observable<any> {
        // return this.http.post(this.PATH, usuario, {  observe: 'response' })
        //     .map(success => success);
        return this.http.post(this.PATH_PETICIONES, usuario, { observe: 'response' })
            .pipe(map(success => success));
    }

    // Delete user
    deleteUserById(userId: string): Observable<number> {
        return this.http.delete(this.PATH + '/' + userId, { observe: 'response' })
            .pipe(map(success => success.status));
    }

    getUsersByClient(clientId: number): Observable<UsuarioCliente[]> {
        return this.http.get<UsuarioCliente[]>(this.PATH + '/Client/' + clientId).pipe(map((usuarios: UsuarioCliente[]) =>
            usuarios.map((usuario: UsuarioCliente) => UsuarioCliente.toModel(JSON.stringify(usuario)))));
    }

    // Users/Parametros/{IdClient}
    getParametrosUsuario(clientId: number): Observable<ParametrosCliente[]> {
        return this.http.get<ParametrosCliente[]>(this.PATH + '/Parametros/' + (clientId ? clientId : '0'));

    }

    updateParams(parametros: ParametrosUpdate[]): Observable<any> {
        return this.http.post(this.PATH + '/Parametros', parametros, { observe: 'response' });
    }

    // 🥑🥑 SRR recuperar si hay que enseñar el video incial
    getMostrarVideoInicial(): Observable<number> {
        const uri = this.PATH_VIDEO_INICIAL;
        return this.http.get<number>(uri);
    }

    // 🥑🥑 SRR actualizar el parametro
    changeParamVideoInicial(): Observable<boolean> {
        const uri = this.PATH_ACT_VIDEO_INICIAL;
        return this.http.get<boolean>(uri);
    }

    //🥑🥑 SRR recuperar si el usuario tiene permisos para extraer series
    getMostrarExtraerSeriesAlmacen(): Observable<boolean> {
        const uri = this.PATH_ACT_EXTRAER_SERIES_ALMACEN;
        return this.http.get<boolean>(uri);
    }

}
